module.exports = "//Default\n<Slider name=\"slider1\" />\n// With starting value\n<Slider name=\"slider2\" defaultValue={0.5} step={0.10} />\n<Slider name=\"slider3\" defaultValue={1} />\n// Disabled with fixed value\n<Slider name=\"slider1\" disabled={true} />\n<Slider name=\"slider2\" disabled={true} value={0.5} />\n<Slider name=\"slider3\" disabled={true} value={1} />\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/sliders-code.txt
 ** module id = 851
 ** module chunks = 0
 **/